import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@mui/material";
import { useSharedAuthLifecycle } from "@shared/auth/useSharedAuthLifecycle";
import ErrorPage from "@shared/components/ErrorPage";
import { RemergeAPIContext } from "@shared/http/remergeApiContext";
import { NullRollbarService, ProductionRollbarService } from "@shared/services/RollbarService";
import TrackingContext from "@shared/services/TrackingContext";
import { useContext } from "react";
import { ErrorBoundary } from "react-error-boundary";
import SherlockDashboard from "./components/SherlockDashboard";
import "./index.css";

const loginBaseURL = import.meta.env.VITE_LOGIN_URL as string;
const rollbarService =
  process.env.NODE_ENV === "production" ? new ProductionRollbarService() : new NullRollbarService();

export default function App() {
  const remergeApi = useContext(RemergeAPIContext);
  const trackingService = useContext(TrackingContext);

  const auth0 = useAuth0();
  const {
    user: resolvedUser,
    isResolvingAuth,
    logout,
  } = useSharedAuthLifecycle({
    remergeApi,
    loginBaseUrl: loginBaseURL,
    auth0,
    onAuthenticated: user => {
      trackingService.identify(user.id.toString(), user.name);
    },
  });

  if (isResolvingAuth) return <CircularProgress />;
  if (resolvedUser && !resolvedUser.admin) return null;
  if (!resolvedUser) return null;

  return (
    <ErrorBoundary FallbackComponent={ErrorPage} onError={onError}>
      <SherlockDashboard userId={resolvedUser.id} logOut={logOut} />
    </ErrorBoundary>
  );

  async function logOut() {
    trackingService.logout();
    await logout();
  }
}

function onError(error: Error) {
  rollbarService.error(error);
  return;
}
